// extracted by mini-css-extract-plugin
export default {"logo":"Expirience_logo__5X07D"};